import { useSyncExternalStore } from 'react';

import { isPocEnabled, subscribeToPocChanges } from './poc-storage';

const usePocEnabled = (pocKey) => useSyncExternalStore(subscribeToPocChanges, () => isPocEnabled(pocKey));

export default usePocEnabled;
